import * as React from 'react'
import { SVGProps, Ref, forwardRef, memo } from 'react'

const SvgSearch = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      d="M11.711 2.43a9.567 9.567 0 1 1 0 19.133 9.567 9.567 0 0 1 0-19.133Zm0 2.014a7.553 7.553 0 1 0 0 15.105 7.553 7.553 0 0 0 0-15.105Zm5.442 12.994c.363-.363.934-.39 1.33-.084l.094.084 4.272 4.273a1.007 1.007 0 0 1-1.329 1.508l-.095-.084-4.272-4.273a1.007 1.007 0 0 1 0-1.424ZM11.71 6.458c1.353 0 2.623.537 3.56 1.475a1.007 1.007 0 1 1-1.424 1.424 3.008 3.008 0 0 0-2.136-.885c-.813 0-1.573.321-2.136.885A1.007 1.007 0 1 1 8.15 7.932a5.022 5.022 0 0 1 3.56-1.474Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
)

const ForwardRef = forwardRef(SvgSearch)
const Memo = memo(ForwardRef)
export default Memo
